import { Box, Chip, PropTypes } from "@material-ui/core";
import React from "react";

interface CarsNumbersToChipProps {
    carNumbers: string[];
    driversByNumber: object;
    style?: React.CSSProperties;
    color?: Exclude<PropTypes.Color, "inherit">;
}

const CarsNumbersToChip: React.FC<CarsNumbersToChipProps> = ({
    carNumbers = [],
    driversByNumber = {},
    color,
    style,
}) => {
    if (carNumbers.length === 0) {
        return null;
    }
    return (
        <Box display="flex" flexWrap="wrap">
            {carNumbers.map((driverNumber, index) => (
                <Chip
                    key={index}
                    label={driversByNumber[driverNumber]}
                    size="small"
                    color={color}
                    style={{
                        fontSize: 12,
                        marginLeft: 4,
                        marginTop: 2,
                        ...style,
                    }}
                />
            ))}
        </Box>
    );
};

export { CarsNumbersToChip };
